<template>
	<span>
      <li role="separator" class="divider"></li>
      <li class="row margin-lateral-10 card">
		<div class="row padding-10">
			<div class="col-md-1">
				<i class="fa" :class="fa_icon" style="margin-left:-10px"></i>
			</div>
			<slot></slot>

		</div>
      </li>
    </span>
</template>

<script>
export default {
  name: 'BaseNotifications',
  props: {
    fa_icon: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
  .card:hover {
    background: #f5f8fa;
    border-radius: 8px;
  }

  .card {
    padding: 10px;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// BaseNotifications.vue?56e58d00